module.exports = __webpack_public_path__ + "static/media/ahituna.15f48ff5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/accessory_image/protein/ahituna.jpg
// module id = 103
// module chunks = 0